import { MicrosoftService } from '@api/api/alfred-integrations';
import { create } from '@terminal/utils/store/createStore';

export const MICROSOFT_SERVICE_TOOL_GROUPS: Record<MicrosoftService, string> = {
  onedrive: 'alfred_integrations_onedrive',
  outlook: 'alfred_integrations_outlook',
  onenote: 'alfred_integrations_onenote',
  teams: 'alfred_integrations_teams',
};

interface ConnectorsStore {
  disabledProviders: string[];
  disabledMicrosoftServices: MicrosoftService[];
  setProviderEnabled: (providerId: string, enabled: boolean) => void;
  setMicrosoftServiceEnabled: (
    service: MicrosoftService,
    enabled: boolean
  ) => void;
}

export const useConnectors = create<ConnectorsStore>(set => ({
  disabledProviders: [],
  disabledMicrosoftServices: [],
  setProviderEnabled: (providerId, enabled) => {
    set(state => {
      const others = state.disabledProviders.filter(id => id !== providerId);

      return {
        disabledProviders: enabled ? others : [...others, providerId],
      };
    });
  },
  setMicrosoftServiceEnabled: (service, enabled) => {
    set(state => {
      const others = state.disabledMicrosoftServices.filter(
        name => name !== service
      );

      return {
        disabledMicrosoftServices: enabled ? others : [...others, service],
      };
    });
  },
}));
